<template>
    <swiper
   :slidesPerView="slidesPerView"
   :spaceBetween="4"
   :lazy="true"
   :pagination="{ clickable: true}"
   :navigation="false"
    :modules="modules"
   class="mySwiper h-[104px]">
<template v-if="loading">
 
    <swiper-slide v-for="n in 4" :key="n" class="w-full h-full text-center border  border-1 rounded rounded-lg overflow-hidden bg-white hover:border-blue-300" >
      <div class="w-16 h-24 mx-auto mt-[0.125rem] bg-wite">
      </div>
      
    </swiper-slide>

</template>

<template v-else>

  <swiper-slide v-for="(item,index) in props.images" :key="index" class="w-full h-full text-center border  border-1 rounded rounded-lg overflow-hidden bg-white hover:border-blue-300" :class="selectTab==index?'border-blue-500':''">
    <div class="w-16 h-24 mx-auto mt-[0.125rem] cursor-pointer">
  
      <img :src='"https://parsinekala.com" + item' @click="changeTabItem(item); selectTab=index"  :alt="props.name" :aria-label="props.name" loading="lazy" class="w-full h-full" />
    </div>
    
  </swiper-slide>

</template>

 

 </swiper>
</template>
<script setup>
import {ref,onMounted,defineProps,defineEmits, watch} from 'vue'
import { Swiper, SwiperSlide } from "swiper/vue";
import { Pagination, Navigation } from 'swiper';
// Import only the CSS styles you need dynamically
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
const modules=[ Pagination, Navigation]
const slidesPerView = ref(8)
const selectTab=ref(0)
const emit=defineEmits(['tabItem'])
const loading=ref(true)
const props = defineProps({
  images: {
    
    type: Array
  },
  name: {
   
    type: String
  }
});

watch(props.images,()=>{
  loading.value=false


})
const changeTabItem=(x)=>{
 emit('tabItem',x)
}
// Update slidesPerView based on page width percentage
const updateSlidesPerView = () => {
 const pageWidthPercentage = window.innerWidth 
 slidesPerView.value=(((pageWidthPercentage)/1025)*3).toFixed(1)
}

onMounted(()=>{
 updateSlidesPerView()
 window.addEventListener("resize",()=>{
 updateSlidesPerView()
})
})
</script>